import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledMainSectionHeader = styled.div(
  ({
    theme: { colors: { ContentText, ContentBackground, Gray20 } } = {} as any,
  }) => css`
    color: ${ContentText};
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    padding: 0 45px 0 24px;
    border-bottom: 1px solid ${Gray20};
    background-color: ${ContentBackground};
  `,
);

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;
